import React, { useState } from "react";
import { useParams } from "react-router-dom";
import {
  Button,
  Paper,
  Box,
} from "@mui/material";
import useCaseList from "../../../hooks/useCaseList.js";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import { negotiationListTable, negotiationListNarrowHide } from "../../../config/grid-column-defs";
import useNarrowColumns from "../../../hooks/useNarrowColumns.js";
import { AddNewDialog } from "../case-negotiation";
import { useSelector } from "react-redux";
import { getCaseNegotiations } from "../../../api/caseNegotiations";
import useSnackbar from "../../../hooks/useSnackbar.js";
import ConditionalRenderer from "../../../components/ConditionalRenderer.jsx";
import useErrorHandler from "../../../hooks/useErrorHandler.js";

export default function CaseNegotiations() {
  // return <></>
  const params = useParams();
  const columns = useNarrowColumns(negotiationListTable, negotiationListNarrowHide);
  const { data: user } = useSelector((state) => state.user);
  const errorHandler = useErrorHandler();
  const [negotiationTableRefreshCount, setNegotiationTableRefreshCount] =
    useState(0);
  function refreshTable() {
    setNegotiationTableRefreshCount((prev) => prev + 1);
  }

  const { selectedCaseName, setSelectedCaseId } = useCaseList();
  setSelectedCaseId(params.id);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [isPrimary, setIsPrimary] = useState(false);

  async function getNegotiationTableData(limit, offset) {
    try {
      const { data } = await getCaseNegotiations(user.token, params.id, {
        limit,
        offset,
      });
      setIsPrimary(data.primary);
      return { rows: data.data, total: data.total, error: false };
    } catch (error) {
      errorHandler(error);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

  const snackbar = useSnackbar();
  async function onAddDone(error = false) {
    if (error) {
      snackbar.showError();
    } else {
      snackbar.showSuccess("Negotiation Added.");
      refreshTable();
    }
  }

  return (
    <>
      <Paper className="odr-card">
        <ConditionalRenderer show={/true/.test(isPrimary)}>
          <Box>
            <Box p={2} display="flex" justifyContent="space-between">
              <Box>
                Negotiations for case <b>{selectedCaseName}</b>
              </Box>
              <Box display="flex" justifyContent="flex-end" columnGap={2}>
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={() => {
                    setDialogOpen(true);
                  }}
                >
                  Add New
                </Button>
              </Box>
            </Box>
          </Box>
        </ConditionalRenderer>

        <Box className="odr-main-table" pt={1}>
          <AgGridPaginatedTable
            columns={columns}
            getTableRows={getNegotiationTableData}
            refreshCounter={negotiationTableRefreshCount}
          />
        </Box>
      </Paper>
      <AddNewDialog
        open={dialogOpen}
        setOpen={setDialogOpen}
        onAddDone={onAddDone}
        token={user.token}
        caseId={params.id}
      />
    </>
  );
}
